<app-hero *transloco="let t" [title]="t('page_query_invoices')"> </app-hero>

<div class="px-8" *transloco="let t">
  <div class="-mt-8 bg-white shadow-md">
    <div class="p-8">
      <div *ngIf="!visibilityToggle">
        <div>
          <h3 class="mb-2 text-xl">01 {{ t("select_engagement") }}</h3>

          <hr class="separator" />

          <div
            class="flex flex-wrap items-stretch gap-8 mb-8"
            [ngClass]="{ 'ui-disabled opacity-70': !submitEnabled }"
          >
            <p-listbox
              #engagementNameListbox
              *ngIf="engagements"
              styleClass="w-[540px] max-w-full filter-text-sm h-full h-80"
              [options]="engagements"
              (onChange)="onEngagementNameListboxChange($event)"
              [filter]="true"
              [filterPlaceHolder]="t('search_name_jobcode_vatnumber')"
              [emptyMessage]="loading ? t('loading') : t('empty_message')"
              optionLabel="searchField"
            >
              <ng-template #item let-engagement>
                <div class="w-full item">
                  <p class="flex justify-between">
                    <span class="font-medium">{{ engagement.name }}</span>
                    <span
                      class="ml-4 text-[13px] whitespace-nowrap text-grey-default"
                      >{{ engagement.jobCode }}</span
                    >
                  </p>
                </div>
              </ng-template>
              <ng-template #footer>
                <ng-container
                  *ngTemplateOutlet="
                    listboxFooterTemplate;
                    context: {
                      $implicit: {
                        listbox: engagementNameListbox,
                        total: engagements.length,
                      },
                    }
                  "
                ></ng-container>
              </ng-template>
            </p-listbox>

            <p-listbox
              #engagementVatNumbersListbox
              *ngIf="selectedEngagement.jobCode"
              styleClass="mr-8 w-[320px] filter-text-sm h-full h-80"
              [(ngModel)]="selectedVatNumber"
              [options]="vatNumbers"
              (onChange)="onEngagementVatNumbersListboxChange($event)"
              [filter]="true"
              [filterPlaceHolder]="t('search_vatnumber')"
            >
              <ng-template #item let-vatNumber>
                <div class="hidden animate-ping"></div>
                <p class="w-full whitespace-nowrap">
                  <span class="float-right -mt-1px">
                    <span
                      *ngIf="
                        selectedVatNumber !== vatNumber ||
                        isValidVatNumber === undefined
                      "
                      class="scale-125 icon-helpQuestion-outline text-grey-medium"
                      [ngClass]="{
                        'animate-ping':
                          selectedVatNumber === vatNumber &&
                          isValidVatNumber === undefined,
                      }"
                    ></span>
                    <span
                      *ngIf="
                        selectedVatNumber === vatNumber &&
                        isValidVatNumber === false
                      "
                      class="scale-125 icon-alert-fill text-status-red"
                    ></span>
                    <span
                      *ngIf="
                        selectedVatNumber === vatNumber &&
                        isValidVatNumber === true
                      "
                      class="scale-125 icon-circleCheckmark-fill text-status-green"
                    ></span>
                  </span>
                  {{ vatNumber }}
                </p>
              </ng-template>
              <ng-template #footer>
                <ng-container
                  *ngTemplateOutlet="
                    listboxFooterTemplate;
                    context: {
                      $implicit: {
                        listbox: engagementVatNumbersListbox,
                        total:
                          selectedEngagement.vatNumbersWithDownloadType.length,
                      },
                    }
                  "
                ></ng-container>
              </ng-template>
            </p-listbox>
          </div>
          <div
            class="grid grid-cols-1 xl:grid-cols-2 xl:gap-x-16 xl:gap-y-2 gap-2"
          >
            <div class="gap-2 w-full">
              <div class="w-full">
                <h3 class="mb-2 text-xl">
                  02 {{ t("dataset") | case: "upperFirst" }}
                </h3>

                <hr class="separator" />

                <div [ngClass]="{ 'ui-disabled opacity-70': !submitEnabled }">
                  <div class="mb-8">
                    <div *ngIf="isValidVatNumber; else elseBlockDataset">
                      <div class="form-table">
                        <form-row
                          template="toggle"
                          fieldName="DatasetReportRequested"
                          [model]="putQueryReqDTO"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                        <form-row
                          template="selectButton"
                          fieldName="DatasetReportInvoiceDirection"
                          [model]="putQueryReqDTO"
                          [selectOptions]="invoiceDirectionSelectOptions"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                        <form-row
                          template="dateRange"
                          fieldName="DatasetReportDatesString"
                          [model]="putQueryReqDTO"
                          calendarDataType="string"
                          [dateOptions]="dateValidatorDTO"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                      </div>
                    </div>

                    <ng-template #elseBlockDataset>
                      <p class="italic text-grey-medium/50">
                        {{ t("please_select_valid_vatnumber_for_engagement") }}
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="gap-2 w-full">
              <div class="w-full">
                <h3 class="mb-2 text-xl">
                  03 {{ t("PowerBi") | case: "upperFirst" }}
                </h3>

                <hr class="separator" />

                <div [ngClass]="{ 'ui-disabled opacity-70': !submitEnabled }">
                  <div class="mb-8">
                    <div
                      *ngIf="
                        isValidVatNumber && isVatAutomatic;
                        else elseBlockBI
                      "
                    >
                      <div class="form-table">
                        <form-row
                          template="toggle"
                          fieldName="PowerBiRequested"
                          [model]="putQueryReqDTO"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                        <form-row
                          template="dateRange"
                          fieldName="PowerBiDatesString"
                          [model]="putQueryReqDTO"
                          calendarDataType="string"
                          [dateOptions]="dateValidatorDTO"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                      </div>
                    </div>

                    <ng-template #elseBlockBI>
                      <p class="italic text-grey-medium/50">
                        <ng-container *ngIf="!isValidVatNumber; else isManual">
                          {{
                            t("please_select_valid_vatnumber_for_engagement")
                          }}
                        </ng-container>
                        <ng-template #isManual>
                          {{
                            t(
                              "please_select_automatic_vatnumber_for_engagement"
                            )
                          }}
                        </ng-template>
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="gap-2 w-full">
              <div>
                <h3 class="mb-2 text-xl">
                  04 {{ t("invoice_details_nav") | case: "upperFirst" }}
                </h3>

                <hr class="separator" />

                <div [ngClass]="{ 'ui-disabled opacity-70': !submitEnabled }">
                  <div class="mb-8">
                    <div *ngIf="isValidVatNumber; else elseBlockInvDetails">
                      <div class="form-table xl:h-[85px]">
                        <form-row
                          template="toggle"
                          fieldName="InvoiceDetailsRequested"
                          [model]="putQueryReqDTO"
                          (toggleOnChangeCallback)="
                            invoiceDetailsOnChange($event)
                          "
                        ></form-row>
                        <form-row
                          template="selectButton"
                          fieldName="InvoiceDetailsInvoiceDirection"
                          [model]="putQueryReqDTO"
                          [selectOptions]="invoiceDirectionSelectOptions"
                        ></form-row>
                      </div>
                      <div>
                        <label class="text-l block">{{
                          t("invoice_numbers")
                        }}</label>
                        <textarea
                          pInputTextarea
                          rows="4"
                          class="w-full"
                          [ngModel]="invoiceDetailsInvoiceNumbersText"
                          (ngModelChange)="
                            onInvoiceDetailsInvoiceNumbersChange($event)
                          "
                        ></textarea>
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="icon-xls-fill -mt-3px mr-1"
                          class="px-0 py-1 p-button-link block"
                          (click)="downloadTemplate()"
                          [label]="t('download_template')"
                        ></button>
                        <app-fileuploader
                          #fileUploader
                          [maxFileSize]="1024 * 1024 * 10"
                          acceptedFileTypes=".xlsx"
                          [auto]="true"
                          [fileLimit]="1"
                          (onUpload)="confirmUploadInvoiceDetails($event)"
                        >
                        </app-fileuploader>
                      </div>
                    </div>
                    <ng-template #elseBlockInvDetails>
                      <p class="italic text-grey-medium/50">
                        {{ t("Please select valid VAT number for engagement") }}
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="gap-2 w-full">
              <div>
                <h3 class="mb-2 text-xl">
                  05 {{ t("InvoiceQuery") | case: "upperFirst" }}
                </h3>

                <hr class="separator" />

                <div [ngClass]="{ 'ui-disabled opacity-70': !submitEnabled }">
                  <div class="mb-8">
                    <div
                      *ngIf="
                        isValidVatNumber && isVatAutomatic;
                        else elseBlockQuery
                      "
                    >
                      <div class="form-table xl:h-[85px]">
                        <form-row
                          template="toggle"
                          fieldName="InvoiceFilteredReportRequested"
                          [model]="putQueryReqDTO"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></form-row>
                      </div>
                      <div>
                        <label class="text-l block">{{
                          t("invoice_numbers")
                        }}</label>
                        <textarea
                          pInputTextarea
                          rows="4"
                          class="w-full"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                          [ngModel]="invoiceFilteredReportInvoiceNumbersText"
                          (ngModelChange)="
                            onInvoiceFilteredReportInvoiceNumbersChange($event)
                          "
                        ></textarea>
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="icon-xls-fill -mt-3px mr-1"
                          class="px-0 py-1 p-button-link block"
                          (click)="downloadTemplate()"
                          [label]="t('download_template')"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        ></button>
                        <app-fileuploader
                          #fileUploader
                          [maxFileSize]="1024 * 1024 * 10"
                          acceptedFileTypes=".xlsx"
                          [auto]="true"
                          [fileLimit]="1"
                          (onUpload)="confirmUpload($event)"
                          [disabled]="putQueryReqDTO.InvoiceDetailsRequested"
                        >
                        </app-fileuploader>
                      </div>
                    </div>
                    <ng-template #elseBlockQuery>
                      <p class="italic text-grey-medium/50">
                        <ng-container *ngIf="!isValidVatNumber; else isManual">
                          {{
                            t("please_select_valid_vatnumber_for_engagement")
                          }}
                        </ng-container>
                        <ng-template #isManual>
                          {{
                            t(
                              "please_select_automatic_vatnumber_for_engagement"
                            )
                          }}
                        </ng-template>
                      </p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="gap-2 w-full">
              <div class="w-full">
                <div class="mb-8" *ngIf="isValidVatNumber">
                  <h3 class="mb-2 text-xl">
                    06 {{ t("finish") | case: "upperFirst" }}
                  </h3>

                  <hr class="separator" />

                  <p-button
                    *ngIf="submitEnabled"
                    icon="icon-play-fill relative -mt-6px -ml-6px text-[20px]"
                    [label]="t('submit_invoice_query')"
                    (click)="showSubmitConfirm()"
                  ></p-button>

                  <div *ngIf="!submitEnabled">
                    <p-button
                      icon="icon-refresh-fill relative -mt-6px -ml-6px text-[20px]"
                      [label]="t('new_invoice_query')"
                      (click)="reset()"
                      styleClass="p-button-secondary"
                    ></p-button>

                    <p class="mt-6">
                      {{ t("invoice_query_initialize_success") }}
                      <br />
                      <a
                        [routerLink]="['/' + statusMonitorPageRoute]"
                        class="inline-block mt-1 underline text-orange-default"
                      >
                        {{ t("check_invoice_query_status_here") }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #listboxFooterTemplate let-data>
  <div class="px-4 py-2 text-xs text-right select-none text-grey-default">
    {{
      data.listbox._filteredOptions
        ? data.listbox._filteredOptions.length
        : data.total
    }}/{{ data.total }}
  </div>
</ng-template>
